import './item.css';

const SKELETON_ROWS = [0, 1, 2, 3];

export const CalendarSkeleton = () => {
  return (
    <div className="calendar__content" aria-hidden="true">
      {SKELETON_ROWS.map((row) => {
        return (
          <div key={row} className="calendar__item calendar__item--skeleton">
            <div className="calendar__item__date">
              <span className="calendar__skeleton-line" />
              <span className="calendar__skeleton-line" />
            </div>

            <div className="calendar__item__wrap">
              <div>
                <span className="calendar__skeleton-line calendar__skeleton-line--title" />
                <span className="calendar__skeleton-line" />
              </div>

              <div>
                <span className="calendar__skeleton-line" />
              </div>
            </div>

            <div className="calendar__item__cta">
              <span className="calendar__skeleton-button" />
            </div>
          </div>
        );
      })}
    </div>
  );
};
